<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center gap-2">
    <i class="fal fa-home"></i>
    <ng-container i18n>Subunit Settings</ng-container>
    <app-page-help articleId="cWz1SL2PRXdzh49of4tSkS" videoId=""></app-page-help>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <mat-form-field2 class="mat-block">
      <input
        type="text"
        formControlName="name"
        matInput
        required
        i18n-placeholder
        placeholder="Name"
        autocomplete="off"
      />
      <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')" i18n>
        Name is required
      </mat-error>
      <mat-error *ngIf="form.get('name').hasError('allNumbers')" i18n> Name cannot be numbers alone. </mat-error>
      <mat-error *ngIf="form.get('name').hasError('allSpaces')" i18n> Name cannot be spaces alone. </mat-error>
      <mat-error *ngIf="form.get('name').hasError('minlength')" i18n>
        Name must be at least 2 characters long
      </mat-error>
      <mat-error *ngIf="form.get('name').hasError('maxlength')" i18n>
        Name must be at most 140 characters long
      </mat-error>
      <mat-error *ngIf="form.get('name').hasError('nameTaken')" i18n>
        Name is already in use by another rental.
      </mat-error>
    </mat-form-field2>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <input
            type="number"
            formControlName="multi_unit_priority"
            matInput
            required
            i18n-placeholder
            placeholder="Priority"
            matTooltip="Defines the booking order for subunits. Higher numbers get booked first."
            i18n-matTooltip
          />
          <mat-error
            *ngIf="form.get('multi_unit_priority').touched && form.get('multi_unit_priority').hasError('required')"
            i18n
          >
            Priority is required
          </mat-error>
          <mat-error *ngIf="form.get('multi_unit_priority').hasError('integer')" i18n>
            value should be integer
          </mat-error>
          <mat-error *ngIf="form.get('multi_unit_priority').hasError('min')" i18n> Min value is 1 </mat-error>
          <mat-error *ngIf="form.get('multi_unit_priority').hasError('max')" i18n> Max value is 100 </mat-error>
          <mat-error *ngIf="form.get('multi_unit_priority').hasError('existing')" i18n>
            Priority already exists
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <app-form-switch
          formControlName="multi_unit_status"
          [checkedValue]="1"
          [uncheckedValue]="0"
          i18n-matTooltip
          matTooltip="When enabled, the subunit is active and available for bookings. When disabled, it cannot be booked but will still appear on the calendar as inactive. You can change this anytime"
          i18n
          style="margin-top: 2.25rem"
          >Status</app-form-switch
        >
      </div>
    </div>
  </form>
  <div class="alert alert-secondary-info mt-3">
    <i class="fal fa-info-circle alert-icon"></i>
    <div class="alert-content" i18n>
      Reservations are auto-assigned based on priority. Adjust the priority here to control the order. Enable the
      subunit to make it bookable, or disable it to keep it inactive - it will still appear on the calendar but won’t
      receive bookings.
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <span class="far fa-times"></span>
    Cancel
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info" [disabled]="loading$ | async">
    <span class="cs-icon cs-icon-save" *ngIf="!(loading$ | async)"></span>
    <span class="far fa-spinner fa-spin" *ngIf="loading$ | async"></span>
    Save
  </button>
</div>
